/* 广告加载事件 */
import { loadScript } from '../../../../base/base/index';

/**
 * 解析广告信息，返回广告回调方法
 * @param { Object } ad
 */
const handleAd = async function handleAd(ad) {
    let callbackFn = null;

    try {
        if (ad.preload) {
            const list = typeof ad.preload === 'string' ? [ad.preload] : ad.preload;
            let index = 0;

            while (list.length > index) {
                const scriptUrl = list[index];

                await loadScript(scriptUrl, { cache: false, reload: false });
                index += 1;
            }
        }

        /* eslint-disable */
        callbackFn = new Function(`return ${ad.callback}`)();
        /* eslint-enable */
    } catch (err) {
        err.message = `AdError - ${err.message}`;

        console.error(err);
        console.error('AdError - AdData', ad);

        // 错误上报
        if (typeof window === 'object' && window.BJ_REPORT) window.BJ_REPORT.report(err);
    }

    return callbackFn;
};

export default handleAd;
